module.exports = __webpack_public_path__ + "media/images/wastebasket-dark-fd4346b63b6ba6b6c7973cba4b2540c5.svg";